var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function () {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (g && (g = 0, op[0] && (_ = 0)), _) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
import { Localization } from 'bernie-l10n';
import { BffClient } from 'shared/http-clients/bff/bff.client';
import { getLocalizedCountry } from 'shared/utils/countries/countries.util';
import { getFormattedLocale, LocaleFormat } from 'shared/utils/locale';
export var getUserProfile = function (state, logger) {
  return {
    queryKey: ['get-profile-partner-details-form', state.user.id],
    queryFn: function () {
      return __awaiter(void 0, void 0, void 0, function () {
        var l10n, bff, formattedLocale, displayCountry, vanityHandle, profileFields;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              l10n = new Localization(state.locale);
              bff = new BffClient(state, logger);
              formattedLocale = getFormattedLocale(state.locale, LocaleFormat.LowerCase);
              displayCountry = getLocalizedCountry(state.user.country, formattedLocale);
              return [4 /*yield*/, bff.partners.getVanityHandle(state.user.partnerId).catch(function () {
                return {
                  vanityHandle: null
                };
              })];
            case 1:
              vanityHandle = _a.sent().vanityHandle;
              profileFields = [vanityHandle && {
                id: 'affiliateTagInput',
                name: 'affiliateTag',
                label: l10n.formatText('profile.your-details.label.affiliate_tag'),
                value: vanityHandle,
                dataCy: 'profile-affiliate-tag',
                readOnly: true
              }, {
                group: [{
                  id: 'signUpFormFirstNameInput',
                  name: 'firstName',
                  label: l10n.formatText('signup.form.label.first_name'),
                  value: state.user.firstName,
                  dataCy: 'sign-up-first-name-field',
                  readOnly: true
                }, {
                  id: 'signUpFormLastNameInput',
                  name: 'lastName',
                  label: l10n.formatText('signup.form.label.last_name'),
                  value: state.user.lastName,
                  dataCy: 'sign-up-last-name-field',
                  readOnly: true
                }]
              }, {
                id: 'signUpFormEmailInput',
                name: 'email',
                label: l10n.formatText('signup.form.label.email'),
                value: state.user.email,
                dataCy: 'sign-up-email-field',
                readOnly: true
              }, {
                id: 'signUpFormCountryInput',
                name: 'country',
                label: l10n.formatText('signup.form.label.country'),
                value: displayCountry,
                dataCy: 'sign-up-country-field',
                readOnly: true
              }, {
                id: 'signUpFormCompanyInput',
                name: 'company',
                label: l10n.formatText('signup.form.label.company'),
                value: state.user.company,
                dataCy: 'sign-up-company-field',
                readOnly: true
              }, {
                id: 'signUpFormWebsiteInput',
                name: 'website',
                label: l10n.formatText('signup.form.label.website'),
                value: state.user.website,
                dataCy: 'sign-up-website-field',
                readOnly: true
              }, {
                id: 'signUpFormPartnerizeIdInput',
                name: 'partnerizeId',
                label: 'Partnerize Publisher Id',
                value: state.user.partnerizeId,
                dataCy: 'sign-up-partnerize-id',
                readOnly: true
              }].filter(Boolean);
              return [2 /*return*/, {
                title: l10n.formatText('profile.dialog.subheading.partner_details'),
                profileFields: profileFields
              }];
          }
        });
      });
    }
  };
};